import { render } from "./DashboardSlider.vue?vue&type=template&id=fbc09478&scoped=true"
import script from "./DashboardSlider.vue?vue&type=script&lang=js"
export * from "./DashboardSlider.vue?vue&type=script&lang=js"

import "./DashboardSlider.vue?vue&type=style&index=0&id=fbc09478&lang=scss"
import "./DashboardSlider.vue?vue&type=style&index=1&id=fbc09478&lang=scss&scoped=true"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbc09478"]])

export default __exports__